import { gql } from '@apollo/client';

export const FETCH_TIME_ZONES = gql`
    query fetchTimeZones {
        lookup {
            timeZones {
                id
                name
                ianaTimeZoneId
                utcOffset
            }
        }
    }
`;
